import { theme } from 'antd';
import { LockIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectTeamsByTeamID } from 'reduxStore/teams/selectors';
import { Notification } from 'zComponents/atoms';
import { Button, Divider, Flex, Modal, Tooltip, Typography } from 'zui/Antd';

const { Title, Text } = Typography;

const RevokeTeamAccessModal = ({ children, visible: visibleProp, setVisible: setVisibleProp, teamID }) => {
	// ✅ Hooks
	const {
		token: { marginXS, paddingMD, marginLG, fontSizeSM, colorWarning, colorTextSolid, paddingLG }
	} = theme.useToken();
	const canManagePermissions = useManagePermittedRoles('aCPermissionManagement');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	// ✅ Local state
	const [internalVisible, internalSetVisible] = useState(false);
	const visible = visibleProp !== undefined ? visibleProp : internalVisible;
	const setVisible = setVisibleProp !== undefined ? setVisibleProp : internalSetVisible;
	const team = useSelector((state) => selectTeamsByTeamID(state, teamID));

	// ✅ Close modal
	const handleCancel = useCallback(() => setVisible(false), [setVisible]);

	// ✅ Handle deletion
	const handleRevoke = () => {
		setTimeout(() => {
			Notification('success', 'Access has been revoked');
			handleCancel();
		}, 500);
	};

	return (
		<>
			<Tooltip title={!canManagePermissions ? permissionDeniedMessage : 'Revoke All Access'}>
				<span onClick={(e) => canManagePermissions && setVisible(true)}>
					{children ? (
						children
					) : (
						<Button
							type='text'
							size='small'
							icon={<LockIcon color='currentColor' />}
							disabled={!canManagePermissions}
						/>
					)}
				</span>
			</Tooltip>

			<Modal
				open={visible}
				onCancel={handleCancel}
				closeIcon={false}
				centered
				width={350}
				destroyOnClose
				footer={[
					<Flex align='center' justify='center' style={{ marginTop: marginLG }} gap={12} key='footer'>
						<Button onClick={handleCancel} type='default' block>
							Cancel
						</Button>
						<Button
							onClick={() => handleRevoke()}
							type='primary'
							style={{ backgroundColor: colorWarning, color: colorTextSolid }}
							block
						>
							Revoke All Access
						</Button>
					</Flex>
				]}
				styles={{ content: { padding: paddingMD } }}
			>
				<Flex vertical align='center' justify='center' gap={12} style={{ padding: `0 ${paddingLG}px` }}>
					<LockIcon width={96} height={96} />
					<Flex vertical gap={marginXS}>
						<Title level={5} style={{ margin: 0, lineHeight: '24px', textAlign: 'center' }}>
							Are you sure you want to revoke all acccess?
						</Title>
						<Text style={{ fontSize: fontSizeSM, lineHeight: '24px', textAlign: 'center' }}>
							All people in this team will lose access to any access permissions previously assigned.{' '}
						</Text>

						<Flex vertical gap={marginXS} style={{ marginBottom: marginXS }}>
							<Divider style={{ marginBottom: 0 }}>
								<Text style={{ fontSize: fontSizeSM, fontWeight: 200 }}>Selected Team</Text>
							</Divider>
							<Text style={{ fontSize: fontSizeSM, textAlign: 'center' }}>{team?.name}</Text>
						</Flex>
					</Flex>
				</Flex>
			</Modal>
		</>
	);
};

export default RevokeTeamAccessModal;
